import { FunctionComponent, ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "@/components";
import { classNames } from "@/utils/classNames";

export interface KpiSectionProps {
	title: string;
	subtitle?: string;
	children: ReactNode;
	className?: string;
	/** Optional tile rendered to the right of the title (e.g. a hero KPI number). */
	headerAccessory?: ReactNode;
	/** Optional FontAwesome icon shown next to the title. */
	icon?: IconDefinition;
}

export const KpiSection: FunctionComponent<KpiSectionProps> = ({
	title,
	subtitle,
	children,
	className,
	headerAccessory,
	icon,
}) => {
	return (
		<section
			className={classNames(
				"w-full max-w-5xl border border-border-light rounded-xl bg-brand-white p-5 mb-4",
				className ?? ""
			)}
		>
			<div className="flex flex-row items-start justify-between gap-4 mb-4">
				<div className="flex flex-row items-center gap-3">
					{icon ? (
						<span className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-action-200 text-blue-action shrink-0">
							<Icon className="w-4 h-4" icon={icon} />
						</span>
					) : null}
					<div className="flex flex-col">
						<h4 className="text-base font-semibold text-text">{title}</h4>
						{subtitle ? <span className="text-sm text-text-meta mt-0.5">{subtitle}</span> : null}
					</div>
				</div>
				{headerAccessory ? <div>{headerAccessory}</div> : null}
			</div>
			<div className="flex flex-col gap-2">{children}</div>
		</section>
	);
};
